import React from 'react';
import blurbPortrait from '../assets/blurb-portrait.png';

export default function Blurb({ children, label = 'A note from me' }) {
  const body = typeof children === 'string' ? <p>{children}</p> : children;

  return (
    <aside className="blurb">
      <img
        src={blurbPortrait}
        alt=""
        className="blurb-portrait"
        width={48}
        height={48}
      />
      <div className="blurb-content">
        <p className="blurb-label">{label}</p>
        <div className="blurb-body">{body}</div>
      </div>
    </aside>
  );
}
